import {Collapse, ToggleButton} from 'react-bootstrap'
import {FieldProps} from 'formik'
import {Message} from '../types'
import clsx from 'clsx'

interface ToggleSectionProps {
  value: string
  field: FieldProps['field']
  resetFieldsForToggle: (type: Message['receiverType']) => void
  id: Message['receiverType']
  label: string
  children: React.ReactNode
}

const ToggleSection = ({field, resetFieldsForToggle, id, label, children}: ToggleSectionProps) => (
  <>
    <ToggleButton
      value={id}
      id={id}
      checked={field.value === id}
      variant={field.value === id ? 'info' : 'light'}
      name={field.name}
      onClick={() => resetFieldsForToggle(id)}
      className={clsx(
        'w-100 border border-secondary rounded-3 fw-light fs-5',
        field.value === id ? 'gradient-btn opacity-75' : ''
      )}
    >
      {label}
    </ToggleButton>
    <Collapse in={field.value === id} unmountOnExit>
      <div>{children}</div>
    </Collapse>
  </>
)

export default ToggleSection
